// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // import "./CategoryList.css";

// // const API = "https://grocerrybackend.vercel.app/api/categories";

// // export default function CategoryList() {
// //   const [categories, setCategories] = useState([]);
// //   const [search, setSearch] = useState("");

// //   // Fetch categories
// //   const fetchCategories = async () => {
// //     try {
// //       const res = await axios.get(API);
// //       setCategories(res.data.categories || []);
// //     } catch (err) {
// //       console.log("Error fetching categories", err);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchCategories();
// //   }, []);

// //   // Filter logic
// //   const filtered = categories.filter((cat) =>
// //     cat.name.toLowerCase().includes(search.toLowerCase())
// //   );

// //   return (
// //     <div className="catlist-container">

// //       {/* 🔍 Search Bar */}
// //       <div className="catlist-search-wrapper">
// //         <div className="catlist-search-box">
// //           <span className="catlist-search-icon">🔍</span>
// //           <input
// //             type="text"
// //             placeholder="Search category..."
// //             className="catlist-search-input"
// //             value={search}
// //             onChange={(e) => setSearch(e.target.value)}
// //           />
// //         </div>
// //       </div>

// //       {/* Category List */}
// //       <div className="catlist-grid">
// //         {filtered.length === 0 ? (
// //           <p className="no-data">No categories found</p>
// //         ) : (
// //           filtered.map((cat) => (
// //             <div key={cat._id} className="cat-item">
// //               <img
// //                 src={cat.image || "https://via.placeholder.com/100"}
// //                 alt=""
// //                 className="cat-thumb"
// //               />
// //               <p className="cat-name">{cat.name}</p>
// //             </div>
// //           ))
// //         )}
// //       </div>
// //     </div>
// //   );
// // }
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./CategoryList.css";

// const API = "https://grocerrybackend.vercel.app/api/categories";

// export default function CategoryList() {
//   const [categories, setCategories] = useState([]);
//   const [search, setSearch] = useState("");

//   // Fetch categories
//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(API);
//       setCategories(res.data.categories || []);
//     } catch (err) {
//       console.log("Error fetching categories", err);
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   // Filter logic
//   const filtered = categories.filter((cat) =>
//     cat.name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div className="catlist-container">

//       {/* 🔍 Search Bar */}
//       <div className="catlist-search-wrapper">
//         <div className="catlist-search-box">
//           <span className="catlist-search-icon">🔍</span>
//           <input
//             type="text"
//             placeholder="Search category..."
//             className="catlist-search-input"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />
//         </div>
//       </div>

//       {/* ---- DESKTOP TABLE ---- */}
//       <div className="catlist-table-wrapper">
//         <table className="catlist-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Image</th>
//               <th>Name</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filtered.length === 0 ? (
//               <tr>
//                 <td colSpan="3" className="no-data">No categories found</td>
//               </tr>
//             ) : (
//               filtered.map((cat, index) => (
//                 <tr key={cat._id}>
//                   <td>{index + 1}</td>
//                   <td>
//                     <img
//                       src={cat.image || "https://via.placeholder.com/100"}
//                       className="catlist-img"
//                       alt=""
//                     />
//                   </td>
//                   <td>{cat.name}</td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ---- MOBILE LIST ---- */}
//       <div className="catlist-mobile-list">
//         {filtered.map((cat, index) => (
//           <div key={cat._id} className="mobile-row">
//             <span className="mobile-index">{index + 1}</span>

//             <img
//               src={cat.image || "https://via.placeholder.com/100"}
//               className="mobile-img"
//               alt=""
//             />

//             <span className="mobile-title">{cat.name}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./CategoryList.css";

const API = "https://grocerrybackend.vercel.app/api/categories";

// export default function CategoryList() {
//   const [categories, setCategories] = useState([]);
//   const [search, setSearch] = useState("");

//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(API);
//       setCategories(res.data.categories || []);
//     } catch (err) {
//       console.log("Fetch error", err);
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const filtered = categories.filter((cat) =>
//     cat.name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div className="catlist-container">
      
//       {/* Search */}
//       <div className="catlist-search-wrapper">
//         <div className="catlist-search-box">
//           <span className="catlist-search-icon">🔍</span>
         
//           <input
//             type="text"
//             placeholder="Search category..."
//             className="catlist-search-input"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />
//         </div>
//       </div>

//       {/* ALWAYS SHOW TABLE (desktop + mobile) */}
//       <div className="catlist-table-wrapper">
//         <table className="catlist-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Image</th>
//               <th>Name</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filtered.length === 0 ? (
//               <tr>
//                 <td colSpan="3" className="no-data">No categories found</td>
//               </tr>
//             ) : (
//               filtered.map((cat, index) => (
//                 <tr key={cat._id}>
//                   <td>{index + 1}</td>
//                   <td>
//                     <img
//                       src={cat.image || "https://via.placeholder.com/100"}
//                       className="catlist-img"
//                       alt=""
//                     />
//                   </td>
//                   <td>{cat.name}</td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import axios from "axios";

// Helper component for the Custom Icon Button
const RowActionButton = ({ children, onClick }) => (
  <button
    onClick={onClick}
    className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-blue-600 hover:bg-blue-50/50 rounded-full transition-colors duration-150"
  >
    {children}
  </button>
);


export default function CategoryList() {
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newCategory, setNewCategory] = useState({
    name: "",
    description: "",
    image: "",
  });
  const [editCategory, setEditCategory] = useState(null);
  const [alertBox, setAlertBox] = useState({
    show: false,
    message: "",
    type: "success",
  });

  // Alert timeout
  useEffect(() => {
    if (alertBox.show) {
      const timer = setTimeout(() => {
        setAlertBox((prev) => ({ ...prev, show: false }));
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [alertBox.show]);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://grocerrybackend.vercel.app/api/categories");
      setCategories(res.data.categories.map(cat => ({
        ...cat,
        totalProducts: Math.floor(Math.random() * 50) + 10,
        description: cat.description || "This is a detailed description of the category.",
      })) || []);
    } catch (err) {
      console.log("Fetch error", err);
      showAlert("❌ Could not fetch categories", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Helper to show alerts
  const showAlert = (message, type) => {
    setAlertBox({ show: true, message, type });
  };

  // Add category
  const handleAddCategory = async () => {
    if (!newCategory.name.trim()) {
      showAlert("❌ Category name is required", "error");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post("https://grocerrybackend.vercel.app/api/categories", {
        name: newCategory.name.trim(),
        description: newCategory.description,
        image: newCategory.image,
      });

      if (res.data?.success) {
        showAlert("✅ Category added successfully", "success");
        setNewCategory({ name: "", description: "", image: "" });
        setShowAddModal(false);
        await fetchCategories();
      }
    } catch (err) {
      console.error("Add category error", err);
      showAlert("❌ Error while adding category", "error");
    } finally {
      setLoading(false);
    }
  };

  // Update category
  const handleUpdateCategory = async () => {
    if (!editCategory.name.trim()) {
      showAlert("❌ Category name is required", "error");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.put(`https://grocerrybackend.vercel.app/api/categories/${editCategory._id}`, {
        name: editCategory.name.trim(),
        description: editCategory.description,
        image: editCategory.image,
      });

      if (res.data?.success) {
        showAlert("✅ Category updated successfully", "success");
        setEditCategory(null);
        await fetchCategories();
      }
    } catch (err) {
      console.error("Update category error", err);
      showAlert("❌ Error while updating category", "error");
    } finally {
      setLoading(false);
    }
  };

  // Delete category
  const handleDeleteCategory = async (id, name) => {
    if (!window.confirm(`Delete category "${name}"?`)) return;
    try {
      await axios.delete(`https://grocerrybackend.vercel.app/api/categories/${id}`);
      showAlert("✅ Category deleted successfully", "success");
      setSelectedCategories(prev => prev.filter(catId => catId !== id));
      fetchCategories();
    } catch (err) {
      console.error("Delete category error", err);
      showAlert("❌ Error while deleting category", "error");
    }
  };

  // Bulk delete
  const handleBulkDelete = async () => {
    if (!selectedCategories.length) {
      showAlert("❌ No categories selected", "error");
      return;
    }
    if (!window.confirm(`Delete ${selectedCategories.length} selected categories?`)) return;

    try {
      await Promise.all(selectedCategories.map((id) => 
        axios.delete(`https://grocerrybackend.vercel.app/api/categories/${id}`)
      ));
      showAlert(`✅ ${selectedCategories.length} categories deleted successfully`, "success");
      setSelectedCategories([]);
      fetchCategories();
    } catch (err) {
      console.error("Bulk delete error", err);
      showAlert("❌ Error while deleting categories", "error");
    }
  };

  // Export CSV Function
  const handleExportCSV = () => {
    try {
      if (categories.length === 0) {
        showAlert("❌ No categories to export", "error");
        return;
      }

      // Prepare CSV data
      const csvData = categories.map(cat => ({
        Name: cat.name,
        Description: cat.description || '',
        Image: cat.image || '',
        'Total Products': cat.totalProducts,
        'Created At': cat.createdAt ? new Date(cat.createdAt).toLocaleDateString() : new Date().toLocaleDateString(),
        'Category ID': cat._id
      }));

      // Convert to CSV format
      const headers = ['Name', 'Description', 'Image', 'Total Products', 'Created At', 'Category ID'];
      
      const escapeCell = (cell) => {
        const str = String(cell);
        if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
          return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
      };

      const csvRows = [
        headers.join(','), // Header row
        ...csvData.map(row => 
          headers.map(header => escapeCell(row[header] || '')).join(',')
        )
      ];

      const csvString = csvRows.join('\r\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      
      // Create download link
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      const timestamp = new Date().toISOString().split('T')[0];
      
      link.setAttribute('href', url);
      link.setAttribute('download', `categories_export_${timestamp}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      showAlert("✅ CSV exported successfully", "success");
    } catch (err) {
      console.error("Export CSV error", err);
      showAlert("❌ Error exporting CSV", "error");
    }
  };

  // Import CSV
  const handleImportCSV = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.name.toLowerCase().endsWith('.csv')) {
      showAlert("❌ Please select a CSV file", "error");
      e.target.value = '';
      return;
    }

    try {
      setLoading(true);
      
      // Read and parse CSV client-side
      const text = await file.text();
      const lines = text.split('\n').filter(line => line.trim());
      
      if (lines.length < 2) {
        showAlert("❌ CSV file is empty or has invalid format", "error");
        e.target.value = '';
        setLoading(false);
        return;
      }

      const headers = lines[0].split(',').map(h => h.trim());
      const categoriesToImport = [];

      // Parse CSV rows
      for (let i = 1; i < lines.length; i++) {
        const line = lines[i];
        if (!line.trim()) continue;

        // Handle quoted values with commas
        const values = [];
        let inQuotes = false;
        let currentValue = '';
        
        for (let j = 0; j < line.length; j++) {
          const char = line[j];
          const nextChar = line[j + 1];
          
          if (char === '"' && !inQuotes) {
            inQuotes = true;
          } else if (char === '"' && inQuotes && nextChar === '"') {
            currentValue += '"';
            j++; // Skip next quote
          } else if (char === '"' && inQuotes) {
            inQuotes = false;
          } else if (char === ',' && !inQuotes) {
            values.push(currentValue);
            currentValue = '';
          } else {
            currentValue += char;
          }
        }
        values.push(currentValue);

        if (values.length >= 1) {
          const category = {
            name: values[0]?.trim() || '',
            description: values[1]?.trim() || '',
            image: values[2]?.trim() || '',
          };
          
          // Only import if name exists
          if (category.name.trim()) {
            categoriesToImport.push(category);
          }
        }
      }

      if (categoriesToImport.length === 0) {
        showAlert("❌ No valid categories found in CSV", "error");
        e.target.value = '';
        setLoading(false);
        return;
      }

      // Import categories one by one
      let successCount = 0;
      let errorCount = 0;
      
      for (const category of categoriesToImport) {
        try {
          await axios.post("https://grocerrybackend.vercel.app/api/categories", category);
          successCount++;
        } catch (catError) {
          console.error(`Failed to import category: ${category.name}`, catError);
          errorCount++;
        }
      }
      
      if (successCount > 0) {
        showAlert(`✅ ${successCount} categories imported successfully${errorCount > 0 ? ` (${errorCount} failed)` : ''}`, "success");
        fetchCategories();
      } else {
        showAlert("❌ All categories failed to import", "error");
      }
      
    } catch (err) {
      console.error("Import error", err);
      showAlert("❌ Import failed. Please check CSV format", "error");
    } finally {
      setLoading(false);
      e.target.value = '';
    }
  };

  const filtered = categories.filter((cat) =>
    cat.name.toLowerCase().includes(search.toLowerCase())
  );

  const toggleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedCategories(filtered.map(cat => cat._id));
    } else {
      setSelectedCategories([]);
    }
  };

  const toggleSelectCategory = (id) => {
    setSelectedCategories(prev =>
      prev.includes(id) ? prev.filter(catId => catId !== id) : [...prev, id]
    );
  };

  const isSelected = (id) => selectedCategories.includes(id);

  const toggleRowExpansion = (id) => {
    setExpandedRowId(prevId => prevId === id ? null : id);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-3 md:p-6">
      {/* Header */}
      <div className="mb-4 md:mb-6">
        <h1 className="text-lg md:text-2xl font-bold text-gray-800">Category Management</h1>
        <p className="text-xs md:text-sm text-gray-600 mt-1">Total: {categories.length} categories</p>
      </div>

      {/* Top Controls */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-3 md:p-4 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-3">
          <input
            type="text"
            placeholder="Search categories..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
          />

          <button
            onClick={() => setShowAddModal(true)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
            disabled={loading}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Add Category
          </button>

          <button
            onClick={handleExportCSV}
            disabled={categories.length === 0 || loading}
            className={`px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2 ${
              categories.length === 0 || loading
                ? 'opacity-50 cursor-not-allowed'
                : 'hover:bg-gray-50'
            }`}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Export CSV
          </button>

          <label className="cursor-pointer">
            <input
              type="file"
              accept=".csv"
              className="hidden"
              onChange={handleImportCSV}
              disabled={loading}
            />
            <span className={`block px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-center transition-colors flex items-center justify-center gap-2 ${
              loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-50'
            }`}>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
              </svg>
              Import CSV
            </span>
          </label>
        </div>

        {/* Bulk Actions */}
        {selectedCategories.length > 0 && (
          <div className="flex items-center justify-between pt-3 border-t border-gray-200">
            <span className="font-medium text-sm">{selectedCategories.length} selected</span>
            <button
              onClick={handleBulkDelete}
              className="px-4 py-1.5 bg-red-100 text-red-700 rounded-lg text-sm font-medium hover:bg-red-200 transition-colors flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Bulk Delete
            </button>
          </div>
        )}
      </div>

      {/* Mobile View - Separate Cards */}
      <div className="md:hidden space-y-3">
        {loading ? (
          <div className="bg-white rounded-xl border border-gray-200 p-6 text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <p className="mt-3 text-sm text-gray-600">Loading categories...</p>
          </div>
        ) : filtered.length === 0 ? (
          <div className="bg-white rounded-xl border border-gray-200 p-6 text-center">
            <svg className="w-12 h-12 text-gray-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
            </svg>
            <p className="text-sm text-gray-500">No categories found</p>
          </div>
        ) : (
          filtered.map((cat, index) => {
            const isCurrentSelected = isSelected(cat._id);
            const isExpanded = expandedRowId === cat._id;

            return (
              <div
                key={cat._id}
                className={`bg-white rounded-xl border ${isCurrentSelected ? 'border-blue-300 bg-blue-50' : 'border-gray-200'} overflow-hidden`}
              >
                {/* Card Header */}
                <div className="p-3 border-b border-gray-100">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3 flex-1 min-w-0">
                      <input
                        type="checkbox"
                        checked={isCurrentSelected}
                        onChange={() => toggleSelectCategory(cat._id)}
                        className="rounded w-4 h-4 border-gray-300"
                      />
                      <img
                        src={cat.image || "https://placehold.co/48x48"}
                        className="w-10 h-10 object-cover rounded-lg border"
                        alt={cat.name}
                        onError={(e) => { e.target.src = "https://placehold.co/48x48"; }}
                      />
                      <div className="flex-1 min-w-0">
                        <div className="font-semibold text-sm text-gray-900 truncate">{cat.name}</div>
                        <div className="flex items-center gap-2 mt-1">
                          <span className="text-xs text-gray-500">Products: {cat.totalProducts}</span>
                          <span className="text-xs text-gray-400">•</span>
                          <span className="text-xs text-gray-500">ID: {cat._id?.slice(-6)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-1">
                      <button
                        onClick={() => toggleRowExpansion(cat._id)}
                        className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                      >
                        <svg className={`w-4 h-4 ${isExpanded ? 'text-blue-600' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      <button
                        onClick={() => setEditCategory(cat)}
                        className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Expanded Content */}
                {isExpanded && (
                  <div className="p-3 bg-gray-50 border-t border-gray-100">
                    <div className="flex gap-3 mb-3">
                      <img
                        src={cat.image || "https://placehold.co/60x60"}
                        className="w-15 h-15 object-cover rounded-lg border"
                        alt={cat.name}
                        onError={(e) => { e.target.src = "https://placehold.co/60x60"; }}
                      />
                      <div className="flex-1">
                        <h4 className="font-bold text-sm text-gray-900 mb-1">{cat.name}</h4>
                        <p className="text-xs text-gray-700 mb-2">{cat.description}</p>
                        <div className="text-xs text-gray-500 truncate">ID: {cat._id}</div>
                      </div>
                    </div>
                    
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleDeleteCategory(cat._id, cat.name)}
                        className="px-3 py-1.5 bg-red-50 text-red-700 rounded-lg text-xs font-medium hover:bg-red-100 transition-colors"
                      >
                        Delete
                      </button>
                      <button
                        onClick={() => setEditCategory(cat)}
                        className="px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg text-xs font-medium hover:bg-blue-100 transition-colors"
                      >
                        Edit Details
                      </button>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* Desktop View - Table */}
      <div className="hidden md:block bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        {loading ? (
          <div className="p-8 text-center">
            <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
            <p className="mt-4 text-gray-600">Loading categories...</p>
          </div>
        ) : filtered.length === 0 ? (
          <div className="p-8 text-center">
            <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
            </svg>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">No categories found</h3>
            <p className="text-gray-600">Try adding a category or adjusting your search</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left">
                    <input
                      type="checkbox"
                      checked={selectedCategories.length === filtered.length && filtered.length > 0}
                      onChange={toggleSelectAll}
                      className="rounded w-4 h-4 border-gray-300"
                    />
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Products</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filtered.map((cat, index) => {
                  const isCurrentSelected = isSelected(cat._id);
                  const isExpanded = expandedRowId === cat._id;
                  
                  return (
                    <React.Fragment key={cat._id}>
                      {/* Main Row */}
                      <tr className={`hover:bg-gray-50 ${isCurrentSelected ? 'bg-blue-50' : ''}`}>
                        <td className="px-6 py-4">
                          <input
                            type="checkbox"
                            checked={isCurrentSelected}
                            onChange={() => toggleSelectCategory(cat._id)}
                            className="rounded w-4 h-4 border-gray-300"
                          />
                        </td>
                        <td className="px-6 py-4 text-gray-500">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4">
                          <img
                            src={cat.image || "https://placehold.co/48x48"}
                            className="w-10 h-10 object-cover rounded-lg border"
                            alt={cat.name}
                            onError={(e) => { e.target.src = "https://placehold.co/48x48"; }}
                          />
                        </td>
                        <td className="px-6 py-4">
                          <div className="font-medium text-sm text-gray-900">
                            {cat.name}
                          </div>
                          <div className="text-xs text-gray-500 mt-1">
                            ID: {cat._id?.slice(-8) || "N/A"}
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                            {cat.totalProducts} products
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => toggleRowExpansion(cat._id)}
                              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                            >
                              <svg className={`w-4 h-4 ${isExpanded ? 'text-blue-600' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                              </svg>
                            </button>
                            <button
                              onClick={() => setEditCategory(cat)}
                              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                              </svg>
                            </button>
                            <button
                              onClick={() => handleDeleteCategory(cat._id, cat.name)}
                              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>

                      {/* Expanded Row */}
                      {isExpanded && (
                        <tr className="bg-blue-50">
                          <td colSpan="6" className="px-6 py-4">
                            <div className="flex gap-4">
                              <img
                                src={cat.image || "https://placehold.co/80x80"}
                                className="w-20 h-20 object-cover rounded-lg border"
                                alt={cat.name}
                                onError={(e) => { e.target.src = "https://placehold.co/80x80"; }}
                              />
                              <div className="flex-1">
                                <h4 className="text-lg font-bold text-blue-800 mb-2">{cat.name}</h4>
                                <p className="text-sm text-gray-700 mb-3">{cat.description}</p>
                                <div className="text-xs text-gray-500 font-mono">
                                  ID: {cat._id}
                                </div>
                                <div className="flex gap-2 mt-3">
                                  <button
                                    onClick={() => handleDeleteCategory(cat._id, cat.name)}
                                    className="px-3 py-1.5 bg-red-100 text-red-700 rounded-lg text-sm font-medium hover:bg-red-200 transition-colors"
                                  >
                                    Delete Category
                                  </button>
                                  <button
                                    onClick={() => setEditCategory(cat)}
                                    className="px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium hover:bg-blue-200 transition-colors"
                                  >
                                    Edit Details
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="mt-4 md:mt-6 px-3 md:px-4 py-2 md:py-3 border-t border-gray-200 bg-gray-50 rounded-lg flex items-center justify-between text-xs md:text-sm text-gray-600">
        <div>Showing {filtered.length} of {categories.length} categories</div>
        <div className="flex items-center gap-2">
          <button
            disabled={true}
            className="w-8 h-8 border border-gray-300 rounded-lg flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            ←
          </button>
          <span className="px-2">1/1</span>
          <button
            disabled={true}
            className="w-8 h-8 border border-gray-300 rounded-lg flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            →
          </button>
        </div>
      </div>

      {/* Add Category Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-4 md:p-6 max-w-sm w-full">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Add Category</h3>
              <button
                onClick={() => setShowAddModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="space-y-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Category Name *</label>
                <input
                  type="text"
                  placeholder="Enter category name"
                  value={newCategory.name}
                  onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Description (optional)</label>
                <textarea
                  placeholder="Enter description"
                  value={newCategory.description}
                  onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Image URL (optional)</label>
                <input
                  type="text"
                  placeholder="Enter image URL"
                  value={newCategory.image}
                  onChange={(e) => setNewCategory({ ...newCategory, image: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                />
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={handleAddCategory}
                disabled={loading}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50 transition-colors"
              >
                {loading ? "Saving..." : "Save Category"}
              </button>
              <button
                onClick={() => setShowAddModal(false)}
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Category Modal */}
      {editCategory && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl p-4 md:p-6 max-w-sm w-full">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Edit Category</h3>
              <button
                onClick={() => setEditCategory(null)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="space-y-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Category Name *</label>
                <input
                  type="text"
                  placeholder="Enter category name"
                  value={editCategory.name}
                  onChange={(e) => setEditCategory({ ...editCategory, name: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                <textarea
                  placeholder="Enter description"
                  value={editCategory.description}
                  onChange={(e) => setEditCategory({ ...editCategory, description: e.target.value })}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Image URL</label>
                <input
                  type="text"
                  placeholder="Enter image URL"
                  value={editCategory.image}
                  onChange={(e) => setEditCategory({ ...editCategory, image: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                />
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={handleUpdateCategory}
                disabled={loading}
                className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 disabled:opacity-50 transition-colors"
              >
                {loading ? "Updating..." : "Update Category"}
              </button>
              <button
                onClick={() => setEditCategory(null)}
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Alert */}
      {alertBox.show && (
        <div className="fixed bottom-4 right-4 z-50">
          <div className={`px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 ${
            alertBox.type === 'success' ? 'bg-green-50 text-green-800 border border-green-200' :
            alertBox.type === 'error' ? 'bg-red-50 text-red-800 border border-red-200' :
            'bg-yellow-50 text-yellow-800 border border-yellow-200'
          }`}>
            <span className="text-sm">{alertBox.message}</span>
            <button
              onClick={() => setAlertBox({ ...alertBox, show: false })}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}